module.exports = __webpack_public_path__ + "d4f6d4c8b3e19472ad4a27d195162624.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/proxima-nova/2E6388_3_0.eot
// module id = 209
// module chunks = 0